import { render } from "./TurnoverChart.vue?vue&type=template&id=25d38332"
import script from "./TurnoverChart.vue?vue&type=script&lang=js"
export * from "./TurnoverChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__